import { getLoggedInUser } from "../AuthService";

export class FeatureFlagService {
  static instance;

  constructor(provider) {
    if (FeatureFlagService.instance) {
      return FeatureFlagService.instance;
    }
    this.provider = provider;
    this.initialized = false; // Initialize to false
    FeatureFlagService.instance = this;
  }

  async initialize(user) {
    try {
      await this.provider.initialize(user);
      this.initialized = true;
    } catch (error) {
      console.error("FeatureFlagService initialization failed:", error);
      this.initialized = false;
      throw error; // Re-throw to propagate the error
    }
  }

  async clear() {
    this.initialized = false;
  }

  async getFeatureFlagValue(key, defaultValue) {
    if (!this.initialized) {
      try {
        const user = getLoggedInUser();
        await this.initialize({ userID: user.uuid, email: user.email });
      } catch (error) {
        // If initialization fails (e.g., missing SDK key), return default value
        console.warn("Feature flag initialization failed, using default value for", key, error);
        return defaultValue;
      }
    }
    return this.provider.getFeatureFlagValue(key, defaultValue);
  }

  async isFeatureEnabled(key, defaultValue) {
    try {
      const value = await this.getFeatureFlagValue(key, defaultValue);
      if (typeof value === "boolean") {
        return value;
      }
      return defaultValue;
    } catch (error) {
      console.error("Error checking feature flag value:", error);
      return defaultValue;
    }
  }
}
